<div
  class="card-container flex w-[325px] h-[180px] flex-col items-start rounded-[25px] shrink-0 transition-all duration-300 my-0 mx-auto"
  [ngStyle]="{
    background: bgColor,
  }"
  [ngClass]="{
    'text-white': cardBrand !== 'migo' && cardBrand !== 'amex',
    'text-mg-neutral-light ': cardBrand === 'migo',
    'text-mg-primary': cardBrand === 'amex',
  }"
>
  <img
    *ngIf="customBackgroundImageUrl"
    [src]="customBackgroundImageUrl"
    (error)="onBackgroundImageError()"
    class="hidden"
    alt=""
    aria-hidden="true"
  />
  <div
    class="flex justify-end items-center self-stretch h-12 gap-2 py-3 px-4 card-alias-container"
  >
    <span
      *ngIf="hasAlias"
      class="flex flex-col uppercase justify-center flex-[1_0_0] self-stretch text-mg-neutral-light text-xs font-normal leading-[120%] card-alias"
      [style.color]="textColor"
      [ngClass]="{
        '!text-mg-white-75':
          !textColor &&
          (cardBrand === 'mastercard' ||
            cardBrand === 'visa-white' ||
            cardBrand === 'unionpay' ||
            cardBrand === 'discover' ||
            cardBrand === 'jcb'),
      }"
    >
      {{ getDisplayAlias }}
    </span>
    <img [src]="cobrandLogo" alt="card logo" class="card-logo" />
  </div>

  <div
    class="flex justify-center items-center gap-[10px] self-stretch h-20 card-number-container"
  >
    <h6
      class="flex flex-col justify-center text-mg-neutral-light text-center font-nova text-[26px] font-normal leading-6 card-number"
      [style.color]="textColor"
      [ngClass]="{
        'text-white': cardBrand !== 'migo' && cardBrand !== 'amex',
        'text-mg-neutral-light ': cardBrand === 'migo',
        'text-mg-primary': cardBrand === 'amex',
      }"
    >
      {{ cardNumber || '0000 0000 0000 0000' }}
    </h6>
  </div>

  <div
    class="flex justify-between items-end shrink-0 self-stretch py-2 pr-3 pl-4 card-footer-container"
  >
    <div class="flex flex-col items-start gap-0 flex-[1_0_0]">
      <p
        class="uppercase text-mg-neutral-light text-xs font-bold leading-[120%] card-name truncate"
        [style.color]="textColor"
        [ngClass]="{
          'text-white': cardBrand !== 'migo' && cardBrand !== 'amex',
          'text-mg-neutral-light ': cardBrand === 'migo',
          'text-mg-primary': cardBrand === 'amex',
        }"
      >
        {{ getDisplayName }}
      </p>
      <p
        class="uppercase text-mg-neutral-light text-right text-xs font-bold leading-[120%] card-date"
        [style.color]="textColor"
        [ngClass]="{
          'text-white': cardBrand !== 'migo' && cardBrand !== 'amex',
          'text-mg-neutral-light ': cardBrand === 'migo',
          'text-mg-primary': cardBrand === 'amex',
        }"
      >
        {{ getFormattedMonth }}/{{ getFormattedYear }}
      </p>
    </div>
    <img class="card-brand" [src]="cardLogo" alt="Card brand logo" />
  </div>
</div>
